import { FC, ImgHTMLAttributes } from 'react';
import img from '@/assets/images/third_app.png';
const AppImg: FC<ImgHTMLAttributes<any>> = (props) => {
  return (
    <img
      {...props}
      src={props.src || img}
      onError={(e) => (e.currentTarget.src = img)}
      alt=' '
    />
  );
};

export default AppImg;
